<template>
  <tm-skeleton-filters
    :left-controls="leftControlsComputed"
    :right-controls="rightControlsComputed"
  />
  <tm-table-skeleton v-bind="$props" />
</template>

<script setup lang="ts">
import { isString } from 'lodash-es'
import { computed, isRef } from '@/composition/vue/compositionApi'
import type { TmTableSkeletonProps } from '@/components/shared/tables/tableBase'
import TmSkeletonFilters from '@/components/shared/skeletons/TmSkeletonFilters.vue'
import TmTableSkeleton from '@/components/shared/tables/TmTableSkeleton.vue'
import { useBreakpoints } from '@/composition/breakpoints'
import type { SkeletonBreakpointsConfig } from '@/components/shared/tables/types.ts'

const breakpoints = useBreakpoints()

const props = withDefaults(
  defineProps<
    TmTableSkeletonProps & {
      leftControls?: string[] | SkeletonBreakpointsConfig[]
      rightControls?: string[] | SkeletonBreakpointsConfig[]
    }
  >(),
  {
    hasActions: true,
  },
)

const calculateControls = (controlsParam: undefined | string[] | SkeletonBreakpointsConfig[]) => {
  if (!controlsParam) {
    return undefined
  }

  if (controlsParam.every((item) => isString(item))) {
    return controlsParam
  }

  for (const { breakpoint, controls } of controlsParam) {
    if (isRef(breakpoints[breakpoint]) && breakpoints[breakpoint].value === true) {
      return controls
    }
  }

  return controlsParam.find((param) => param.breakpoint === 'default')?.controls ?? undefined
}

const leftControlsComputed = computed(() => calculateControls(props.leftControls))
const rightControlsComputed = computed(() => calculateControls(props.rightControls))
</script>
